'use strict';

angular.module('atex.dam').controller('DamPhysicalPagesViewController', [
  '$rootScope', '$scope', '$timeout', '$window', "$q",
  'DamListService', 'DamSearchService', 'DamStatusService', 'UIConfigurationService', 'ApplicationConfigurationService',
  function ($rootScope, $scope, $timeout, $window, $q,
   DamListService, DamSearchService, DamStatusService, UIConfigurationService, ApplicationConfigurationService) {

  $scope.singleEdition = false;
  $scope.selectedEdition = undefined;
  $scope.show1stLeftPage = true;
  $scope.hasLogicalPages = true;

  function _singleEdition() {
    $scope.left = $('#dam-list-list').scrollLeft();
    $scope.top = $('#dam-list-list').scrollTop();

    $('#dam-list-list').scrollLeft(0);
    $('#dam-list-list').scrollTop(0);
  }


  function _allEditions() {
    if ($scope.left || $scope.top) {
      $scope.positioning = true;

      $timeout(function () {
        if ($scope.left) {
          $('#dam-list-list').scrollLeft($scope.left);
        }

        if ($scope.top) {
          $('#dam-list-list').scrollTop($scope.top);
        }
      });
      $scope.positioning = false;
    }
  }

  function create(edition) {
    return {
      edition: edition,
      id: edition.replace(/ +/g, ''),
      pages: []
    };
  }

  function addStatusColour(entry) {
    function getStatusColour(statusId) {
      return DamStatusService.getStatusById('atex.WFStatusList', statusId).then(function (status) {
        var colour =  status ? status.color : "";
        if (!atex.dam.AngularUtils.isHexColor(colour)) {
          colour = atex.dam.AngularUtils.getHex(colour);
        }
        return colour;
      });
    }

    if (!$scope.hasLogicalPages) {
      var statusId = atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/contentData/data/statusID');
      entry.colour = "";
      if (statusId) {
        getStatusColour(statusId).then(function (colour) {
          entry.colour = colour;
        });
      }
    }
  }

  function reviews(entries) {
    UIConfigurationService.userprofile("print-data/editions", $scope.profile).then(function (editions) {
      $scope.reviews = [];

      var _reviews = [];
      _.each(entries, function (entry) {
        addStatusColour(entry);

        var edition = atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/contentData/data/edition') || "default";
        var zone = atex.onecms.ObjectUtils.getByPath(entry, '_data/aspects/contentData/data/zone');
        if (typeof zone !== "undefined") {
          edition += " - " + zone;
        }

        var review = _.find(_reviews, function (review) {
          return review.edition === edition;
        });

        if (!review) {
          review = create(edition);
          _reviews.push(review);
        }

        review.pages.push(entry);
      });

      if (editions && editions.length > 0 && _reviews.length > 1) {
        _.each(editions, function (edition) {
          var _review = _.find(_reviews, function (_review) {
            return _review.edition === edition;
          });

          if (_review) {
            $scope.reviews.push(_review);
            _reviews = _.without(_reviews,  _.findWhere(_reviews, {
              "edition": edition
            }));
          }
        });

        if (_reviews && _reviews.length > 0) {
          _.each(_reviews, function (_review) {
            $scope.reviews.push(_review);
          });
        }
      } else {
        _.each(_reviews, function (_review) {
          $scope.reviews.push(_review);
        });
      }
      if ($scope.reviews && $scope.reviews.length > 0) {
        $scope.selectedEdition = $scope.reviews[0].edition;
      }
    });
  }

  function reset() {
    if($scope.singleEdition) {
      $('.img-responsive').attr('style', 'height: auto !important');
      return;
    }
    var reviews = $('.dam-list-physical-pages');
    if (reviews && reviews.length > 0) {
      for (var i = 0; i < reviews.length; i++) {
        var review = reviews.get(i);
        if (review) {
          var label = $(review).find('.physical-pages-edition-fixed');
          if (label && label.length > 0) {
            label = $(label).get(0);

            var height = getHeightValueOf(review) - 10;
            var top = 128 - getOffsetTopValueOf(review);
            var offset = getOffsetTopValueOf(review);

            if (top > 0) {
              height = height - top;
              offset = offset + top;

              $(label).css('border-bottom-right-radius', "0");
              $(label).css('border-bottom-left-radius', "0");
              $(label).css('border-bottom', 'none');
            } else {
              $(label).css('border-radius', "4px");
              $(label).css('border', 'solid 1px green');
            }

            if (height > 0) {
              $(label).css('height', height);
              $(label).css('display', 'block');
            } else if (height <= 0) {
              $(label).css('display', 'none');
            }

            $(label).css('top', offset);
          }
        }
      }
    }
  }

  function parse(value) {
    if (value.indexOf('px') > -1) {
      value = value.split('px')[0];
    }

    return value;
  }

  function getOffsetTopValueOf(entry) {
    var offset = 0;

    if (entry) {
      offset = $(entry).offset().top;
    }

    return Number(offset);
  }

  function getHeightValueOf(entry) {
    var height = 0;

    if (entry) {
      height = $(entry).css('height');
      height = parse(height);
    }

    return Number(height);
  }

  function getWidthValueOf(entry) {
    var height = 0;

    if (entry) {
      height = $(entry).css('width');
      height = parse(height);
    }

    return Number(height);
  }

  function getCurrentSelection() {
    var current;

    var selected = DamListService.getSelected();
    if (selected) {
      var selection = selected[(selected.length - 1)];

      if ($scope.reviews) {
        $scope.reviews.forEach(function (review) {
          review.pages.forEach(function (page, key) {
            if (page.id === selection.id) {
              current = {
                index: key,
                pages: review.pages
              };
            }
          });
        });
      }
    }

    return current;
  }

  function setNextSelection(position) {
    var current = getCurrentSelection();

    if (current) {
      var key = current.index + position;

      if (key >= 0 && key < current.pages.length) {
        var obj = current.pages[key];
        if (obj) {
          shift(key, (position === -1));
          DamListService.clearSelection();
          DamListService.addSelection(obj);
          $scope.$root.$broadcast('dam:setPreviewingItem', obj);
        }
      }
    }
  }

  function shift(index, left) {
    var entries = $('.physical-pages-entry');
    if (entries && entries.length > 0) {
      var width = getWidthValueOf(entries.get(0));
      var shift = (width * index);

      var _ratio = $scope.ratio;
      if ($scope.ratio === 2) {
        _ratio = 7;
      } else if ($scope.ratio === 3) {
        _ratio = 6;
      } else if ($scope.ratio === 4) {
        _ratio = 5;
      } else if ($scope.ratio === 5) {
        _ratio = 4;
      } else if ($scope.ratio === 6) {
        _ratio = 3;
      }

      if (parseInt(index % _ratio) === 0 && !left) {
        $('#dam-list-list').scrollLeft(shift);
      } else if (left && parseInt((index + 1) % _ratio) === 0) {
        var _index = index - (_ratio - 1);
        shift = (width * _index);
        $('#dam-list-list').scrollLeft(shift);
      }
    }
  }

  function entries() {
    // We need to sort the entries in the results array to match the screen display otherwise when rows are selected
    // they don't select properly
    $scope.entries.sort(function (a, b) {
      var paths=['_data/aspects/contentData/data/edition','_data/aspects/contentData/data/zone','_data/aspects/contentData/data/' + $scope.pageSequencePath];
      var compare=[];
      for (var i = 0; i < paths.length; i++) {
        compare[i] = {};
        compare[i].a = atex.onecms.ObjectUtils.getByPath(a, paths[i]);
        compare[i].b = atex.onecms.ObjectUtils.getByPath(b, paths[i]);
      }
      for (i = 0; i < compare.length;i++) {
        var a1 = compare[i].a;
        var b1 = compare[i].b;
        // Both values are undefined, so treat as equality (e.g. if zone is not present)
        if (typeof a1 === 'undefined' && typeof b1 === 'undefined') {
          continue;
        }
        // a is undefined, but b is not, so a comes first (b cannot be undefined here)
        if (typeof a1 === 'undefined') {
          return -1;
        }
        // Compare using numerics to allow for page numbers which might be zero padded (p-Series) or not zero padded (H-Series)
        var diff = a1.localeCompare(b1, undefined, {numeric: true, sensitivity: 'base'});
        if (diff !== 0) {
          return diff;
        }
      }
      return 0;
    });
    $scope._entries = angular.copy($scope.entries);
    $scope.$root.$broadcast('dam:count-items', $scope._entries.length);

    var query = DamSearchService.getCurrentPhysicalPagesQuery();
    if (query.isDynamic === "true") {
      $scope._entries = _.sortBy($scope._entries, function (entry) {
        return Number(entry._data.aspects.contentData.data[$scope.pageSequencePath]);
      });
    }

    reviews($scope._entries);
  }

  var printPageUrl = "";
  $scope.pageSequencePath = "pageSequence";

  var printSystemPromise =  ApplicationConfigurationService.getConfigurationFor(['printSystem']),
    oneCMSUrlPromise = ApplicationConfigurationService.getConfigurationFor(['printPageUrl']);

  $q.all([printSystemPromise, oneCMSUrlPromise]).then(function(result) {
    var printSystem = result[0];
    var url = result[1];

    if (printSystem && typeof printSystem.hasPHPages !== "undefined") {
      // printSystem.hasPHPages ? hermes : prestige
      $scope.pageSequencePath = printSystem.hasPHPages ? "pageSequence" : "printPage";
      $scope.show1stLeftPage = printSystem.hasPHPages;
      $scope.hasLogicalPages = printSystem.hasPHPages;
    }

    if (url && !_.isEmpty(url)) {
      printPageUrl = url;
    }

    entries();
    reset();
  });

  $scope.switch = function(_edition) {
    $scope.selectedEdition = (_edition) ? _edition : $scope.reviews[0].edition;
    if (!$scope.singleEdition) {
      _singleEdition();
    } else {
      _allEditions();
    }

    $scope.singleEdition = !$scope.singleEdition;
    $scope.$root.$broadcast("dam:resetSliderEvent", {display: $scope.singleEdition ? 4 : 3});
  };

  $scope.editPage = function ( entry ) {
    if (printPageUrl && !_.isEmpty(printPageUrl)) {
      var url = printPageUrl + "/#/edit/" + atex.onecms.ObjectUtils.getByPath(entry, '_data/id');

      $window.open(url, '_blank').focus();
    }
  };

  function _refresh() {
    $scope.left = $('#dam-list-list').scrollLeft();
    $scope.top = $('#dam-list-list').scrollTop();
    DamSearchService.refresh();
  }

  $scope.singleEdition = $rootScope.physSingleEdition;

  $scope.ratio = 3;

  $scope.cleanId = function(contentId) {
    if(contentId) {
      return atex.dam.AngularUtils.removePrefix(contentId);
    }
  };

  $rootScope._changeMode = function(singleEdition) {
    if (singleEdition === $scope.singleEdition) {
      $scope.show('physical-page');
      return;
    }

    if (singleEdition) {
      $scope.selectedEdition = ($scope.selectedEdition) ? $scope.selectedEdition : $scope.reviews[0].edition;
      _singleEdition();
    } else {
      _allEditions();
    }

    $scope.singleEdition = singleEdition;
    $scope.$root.$broadcast("dam:resetSliderEvent", {display: $scope.singleEdition ? 4 : 3});
  };

  $rootScope._isSingleEdition = function() {
    return $scope.singleEdition;
  };

  $rootScope._switch = function() {
    $scope.switch();
  };

  $rootScope.refreshPhysPage = function() {
    _refresh();
  };

  $rootScope.moveRight = function () {
    setNextSelection(1);
  };

  $rootScope.moveLeft = function () {
    setNextSelection(-1);
  };

  $rootScope.$on("dam:slider-changed", function () {
    reset();
  });

  $rootScope.$on("dam:displayChangeEvent", function (event, _ratio) {
    $scope.ratio = _ratio.display;
  });

  $scope.$on("dam:view-change", function () {
    $timeout(function () {
      reset();
    }, 1);
  });

  $scope.$on("dam:search", function (event, search) {
    $scope.singleEdition = atex.onecms.ObjectUtils.getByPath(search, 'container/aspects/contentData/data/singleEdition') === true;
    $scope.reviews.length = 0;
    $scope._entries.length = 0;
    $scope.entries = atex.onecms.ObjectUtils.getByPath(search, 'response/docs') || [];
    entries();

    if ($scope.left || $scope.top) {
      $scope.positioning = true;

      $timeout(function () {
        if ($scope.left) {
          $('#dam-list-list').scrollLeft($scope.left);
          $scope.left = undefined;
        }

        if ($scope.top) {
          $('#dam-list-list').scrollTop($scope.top);
          $scope.top = undefined;
        }

        $scope.positioning = false;
      });
    }
  });

  $rootScope.$on("dam:user-profile-updated",function (event, profile) {
    $scope.profile = profile;
    if ($scope.reviews.length > 1) {
      _refresh();
    }
  });

  $rootScope.$on("dam:contentRemoved", function (event, id, increment) {
    if($scope.damid === id && $scope.increment !== increment) {
      $scope.increment = increment;
      _refresh();
    }
  });

  $rootScope.$on("dam:contentAdded", function (event, id, increment) {
    if ($scope.damid === id && $scope.increment !== increment) {
      $scope.increment = increment;
      if ($scope.$root) {
        $scope.$root.$broadcast('dam:add-count-items', increment);
      }
    }
  });

  $rootScope.$on("dam:physpage-updatedItem", function (event, entry) {
      $scope.reviews.forEach(function (edition) {
        var content = _.findWhere(edition.pages, {id: entry.id});
        if (content) {
          _.extend(content, entry);
          addStatusColour(content);
        }
      });
  });

  $rootScope.$on("dam:queryListSearch", function () {
    $scope.increment = undefined;
  });

  $scope.$on("dam:searchNewItems", function (event, searchResponseData) {
    $timeout(function () {
      if ($scope.damid === searchResponseData.damid) {
        var documents = atex.onecms.ObjectUtils.getByPath(searchResponseData, "response/docs") || [];
        if (documents.length > 0) {
          _.each(documents, function (document) {
            var _edition = atex.onecms.ObjectUtils.getByPath(document, '_data/aspects/contentData/data/edition');
            var _zone = atex.onecms.ObjectUtils.getByPath(document, '_data/aspects/contentData/data/zone');
            if (typeof _zone !== "undefined") {
              _edition += " - " + _zone;
            }

            var edition = _.find($scope.reviews, function (review) {
              return (review.edition === _edition);
            });

            if (!edition) {
              edition = create(_edition);
              $scope.reviews.push(edition);
            }

            var content = _.findWhere(edition.pages, {id: document.id});
            if (content) {
              if (document.atex_desk_version !== content.atex_desk_version) {
                _.extend(content, document);
                addStatusColour(content);

                edition.pages = _.sortBy(edition.pages, function (page) {
                  return Number(page._data.aspects.contentData.data[$scope.pageSequencePath]);
                });
              }
            } else {
              $scope.style = $rootScope.sliderValue;
              $scope.imgStyle = $rootScope.physPageThumbHeight;

              addStatusColour(document);
              edition.pages.push(document);
              edition.pages = _.sortBy(edition.pages, function (page) {
                return Number(page._data.aspects.contentData.data[$scope.pageSequencePath]);
              });
            }
          });

          UIConfigurationService.userprofile("print-data/editions", $scope.profile).then(function (editions) {
            if (editions && editions.length > 0 && $scope.reviews.length > 1) {
              var _editions = _.intersection(editions, _.pluck($scope.reviews, "edition"));
              if (!_.isEqual(_.pluck($scope.reviews, "edition"), _editions)) {
                var _reviews = angular.copy($scope.reviews);
                $scope.reviews = [];

                _.each(editions, function (edition) {
                  var _review = _.find(_reviews, function (_review) {
                    return _review.edition === edition;
                  });

                  if (_review) {
                    $scope.reviews.push(_review);
                    _reviews = _.without(_reviews, _.findWhere(_reviews, {
                      "edition": edition
                    }));
                  }
                });

                if (_reviews && _reviews.length > 0) {
                  _.each(_reviews, function (_review) {
                    $scope.reviews.push(_review);
                  });
                }
              }
            }
          });
        }
      }
    });
  });

  $(window).on('resize', function () {
    reset();
  });

  $('#dam-list-list').bind('scroll', function () {
    reset();
  });

    $scope.$on("dam:updatedItem", function(event, asset) {
      if (!asset || !asset.id || !asset.status) {
        return;
      }
      $scope.reviews.forEach(function (review) {
        review.pages.forEach(function (page, key) {
          var logPages = atex.onecms.ObjectUtils.getByPath(page, '_data/aspects/contentData/data/pages');
          if (logPages && logPages.length > 0) {
            logPages.forEach(function(logPage) {
              if (logPage.contentId === 'contentid/' + asset.id) {
                logPage.statusColor = asset.status.color;
                logPage.statusName = asset.status.name;
              }
            });
          }
        });
      });
    });
}]);
